module.exports = __webpack_public_path__ + "static/media/network.f25c074f.svg";